import dynamic from "next/dynamic";
import WelcomeNewJoinersFooterConfig from "./welcome-new-joiners-footer-config";
import WelcomeNewJoinersFooterAdvancedConfig from "./welcome-new-joiners-footer-advanced-config";
const WelcomeNewJoinersFooterComponent = dynamic(()=>import("./welcome-new-joiners-footer-component"));
export default {
    WelcomeNewJoinersFooterComponent,
    WelcomeNewJoinersFooterConfig,
    WelcomeNewJoinersFooterAdvancedConfig
};
